export default __webpack_public_path__ + "static/media/Metamask_Light.b6b3749b.svg";